module.exports = __webpack_public_path__ + "static/Testimonial_Max_Schoeppe-80afdd51dd8009ac6c00ea7dc5951c49.png";